<template>
    <div class="story-maker-sticker story-maker-sticker-localisation">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div class="sticker-localisation" :class="`style${styleVariant}`">
           <div class="icon"></div>
            <p>{{ place.name ? place.name : '' }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: Number | String,
            place: Object,
            styleVariant: Number,
            setCbClick: Function,
        },
        mounted () {
            if (this.setCbClick) this.setCbClick(this.changeStyleVariant);
        },
        methods: {
            changeStyleVariant(e) {
                this.$emit('updateSticker',this.id , {
                    data : {
                        place : this.place,
                        styleVariant :(this.styleVariant % 6) + 1
                    },
                })
            }
        },
    }
</script>
